import { ArrowRight } from "lucide-react";
import "./TnsNews.css";

const news = [
  {
    id: 1,
    title:
      "Sabre opens travel infrastructure to Silicon Valley developers building the next AI agents at Bay Area hackathon",
    image:
      "/assets/homenews.png",
    category: "NEWSROOM",
    date: "24 July 2026",
    featured: true,
    link: "https://www.sabre.com/resources/newsroom/sabre-opens-travel-infrastructure-to-silicon-valley-developers-building-the-next-ai-agents-at-bay-area-hackathon/",
  },
  {
    id: 2,
    title:
      "Sabre scales agentic AI deployment as Ultra Group expands globally...",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/blog-card1.png",
    category: "NEWSROOM",
    date: "24 July 2026",
    link: "https://www.sabre.com/resources/newsroom/sabre-scales-agentic-ai-deployment-as-ultra-group-expands-globally-under-linex/",
  },
  {
    id: 3,
    title:
      "Mindtrip launches travel's first all-in-one agentic AI flight booking...",
    image:
      "/assets/news.png",
    category: "NEWSROOM",
    date: "24 July 2026",
    link: "https://www.sabre.com/resources/newsroom/mindtrip-launches-travels-first-all-in-one-agentic-ai-flight-booking-experience-powered-by-partnership-with-sabre-and-paypal/",
  },
  {
    id: 4,
    title: "Sabre announces extension of partnership with TNS Global...",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/blog-card3.png",
    category: "NEWSROOM",
    date: "24 July 2026",
    link: "https://www.sabre.com/resources/newsroom/sabre-announces-extension-of-partnership-with-tns-global-to-strengthen-its-position-in-east-africa/",
  },
  {
    id: 5,
    title:
      "Sabre appoints Niklas Andréen as Chief Commercial Officer, Airline Tech...",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/blog-card4.png",
    category: "NEWSROOM",
    date: "24 July 2026",
    link: "https://www.sabre.com/resources/newsroom/sabre-appoints-niklas-andreen-as-chief-commercial-officer-airline-tech/",
  },
];

function TnsNews() {
  const featured = news.find((item) => item.featured);
  const list = news.filter((item) => !item.featured);

  return (
    <section className="tns-news-section section-padding">
      <div className="news-header">
        <div className="news-header-div">
          <h2 className="heading-title">
            News &<span className="title-blue"> Announcements</span>
          </h2>

          <p className="desc " style={{ textAlign: "left" }}>
            TNS Global, in partnership with Sabre Corporation, is expanding its
            Global Distribution System (GDS) across 14 high-growth.
          </p>
        </div>

        <a
          className="read-btn-a"
          href="https://www.sabre.com/resources/newsroom"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="read-btn">
            READ ALL
            <img src="/assets/arrow.svg" alt="arrow" className="btn-arrow" />
          </button>
        </a>
      </div>

      <div className="news-grid">
        {/* Left Featured */}

        <div
          className="featured-card"
          onClick={() => window.open(featured.link, "_blank")}
          style={{ cursor: "pointer" }}
        >
          <h3>{featured.title}</h3>

          <img src={featured.image} alt="" />

          <div className="featured-footer">
            <span>{featured.category}</span>
            <span style={{ color: "#9CA3AF" }}>{featured.date}</span>
          </div>
        </div>

        {/* Right List */}

        <div className="news-list">
          {list.map((item) => (
            <div
              className="news-card"
              key={item.id}
              onClick={() => window.open(item.link, "_blank")}
              style={{ cursor: "pointer" }}
            >
              <img src={item.image} alt="" />

              <div className="tns-news-content">
                <div className="news-meta">
                  {item.category}
                  <span>{item.date}</span>
                </div>

                <h4>{item.title}</h4>
              </div>

              <button className="news-arrow">
                <ArrowRight />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TnsNews;
